import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpServiceService } from 'src/app/http-service.service';
import { UtilService } from 'src/app/util.service';
import { LoaderService } from 'src/app/loader.service';
import { AlertService } from 'src/app/alert.service';

@Component({
  selector: 'app-project-list',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.css']
})
export class ProjectListComponent implements OnInit {
  clients: any = {}
  json: any=[];
  services:any={}
  constructor(private router: Router, 
    public httpService: HttpServiceService, public alertService: AlertService,
    public util:UtilService,
    public loaderService: LoaderService) {

  }

  async loadData(){
    this.loaderService.showLoader('Fetching Please wait ..').then(()=>{
      try{
        this.httpService.getApi('Project/getAllProjects').subscribe(async(res: any) => {
          if (res.success) {
            console.log(res)
            this.json = res.success.project;
             console.log(this.json)
             await this.getclient()
             await this.getServices()
          }
         
          this.loaderService.hideLoader();
         },(err)=>{
          
          this.loaderService.hideLoader();
          this.alertService.presentNetworkAlert();
         });
      }catch(e){
        this.loaderService.hideLoader();
      }
   
    });
  }

  async ngOnInit() {
    this.loadData();
  }


  getclient()
  {
    console.log("clients")
    return new Promise(resolve => {
      this.json.forEach(element => {
          this.httpService.postApi(element['client'], 'Client/getbyid/' + element['client']).subscribe((res: any) => {
            if (res.success) {
              console.log(res)
               this.clients[element['client']] = res.success.client[0]
               console.log(this.clients)
            }
          });
      })
      resolve(1)      
    })
  }



  add() {
    this.router.navigate(['/project-add'])
  }

  details(data) {
    localStorage.setItem('projectDetails', JSON.stringify(data));
    this.router.navigate(['/project-details'])
  }


  getServices() {
    console.log("services")
    return new Promise(resolve => {
      this.json.forEach(element => {
          this.httpService.postApi(element['serviceType'], 'Servicetype/getServiceById/' + element['serviceType']).subscribe((res: any) => {
            if (res.success) {
              console.log(res)
               this.services[element['serviceType']] = res.success.servicetype
               console.log(this.services)
            }
          });
      })
      resolve(1)      
    })
  }
}
